"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArdadImages = void 0;
const pattern_library_utils_logger_1 = __importDefault(require("@saatva-bits/pattern-library.utils.logger"));
const pattern_library_modules_selection_1 = require("@saatva-bits/pattern-library.modules.selection");
/**
 * Generates an array of image objects based on the provided product state, descriptors, aspect ratios,
 * alt tag, and product tag. Filters out descriptors that are not relevant (e.g., 'video', 'ar').
 *
 * @param {Object} productState - The state of the product containing details like productCode and sku.
 * @param {string[]} [descriptors=[]] - An array of descriptors used to determine the assets to fetch.
 * @param {Object} aspectRatios - The aspect ratios used to fetch the appropriate asset.
 * @param {string} altTag - The alt text for the images.
 * @param {string} [productTag] - An optional tag to be applied to the first image.
 * @returns {Object[]} An array of image objects, each containing id, tag, alt, folder, and filename properties.
 *
 * @throws Will log a debug message if an asset cannot be found for a given descriptor.
 */
const getArdadImages = (productState, descriptors = [], aspectRatios, altTag, productTag) => {
    const images = [];
    descriptors.forEach((descriptor, i) => {
        const ignoredDescriptors = ['video', 'ar'];
        if (ignoredDescriptors.includes(descriptor))
            return;
        try {
            const tag = productTag && i === 0 ? productTag : '';
            const id = `${altTag}-${i}`;
            const { folder, file } = (0, pattern_library_modules_selection_1.getAssetForVariant)(productState, descriptor, aspectRatios);
            images.push({
                id,
                tag,
                alt: altTag,
                folder,
                filename: file
            });
        }
        catch (err) {
            pattern_library_utils_logger_1.default.debug({
                message: 'Cannot find ARDAD asset for variant in Cart detail modal',
                location: 'components.ProductDetailModal.ardadImages',
                details: {
                    productCode: productState.productCode,
                    sku: productState.sku,
                    descriptor
                },
                err
            });
        }
    });
    return images;
};
exports.getArdadImages = getArdadImages;
//# sourceMappingURL=ardad.js.map